import React, { useState } from "react";
import { useSelector } from "react-redux";
import MapWithMarkers from "./MapWithMarkers";

const StyledMapWithAnInfoBox = () => {
  const { latitude, longitude, resellers } = useSelector((state) => state.googleMap),
    [openMarkerId, setOpenMarkerId] = useState("");

  const markers = resellers.flatMap((reseller, index) =>
    reseller.resellerItems.map((item, tindex) => {
      const coordinates = item.coordinates.split(",");
      return {
        id: `${index}_${tindex}`,
        position: {
          lat: parseFloat(coordinates[0]),
          lng: parseFloat(coordinates[1]),
        },
        info: item,
      };
    })
  );

  return (
    <MapWithMarkers
      center={{ lat: parseFloat(latitude), lng: parseFloat(longitude) }}
      zoom={5}
      markers={markers}
      openMarkerId={openMarkerId}
      onMarkerClick={setOpenMarkerId}
      onInfoWindowClose={() => setOpenMarkerId("")}
    />
  );
};

export default StyledMapWithAnInfoBox;
